export default function resultsSlider() {

	if ($(".results_slider__js").length > 0) {

		// if ( $(window).width() <= '968' &&  $(window).width() > '540') {
		$('.results_slider__js').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			appendDots: $('.results__js'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
					}
				},
			]
		});
	}
}